import { UseQueryOptions, UseQueryResult, useQuery } from 'react-query';
import { FieldSectionType } from 'api/field-sections/types';
import { FieldsAPI } from 'api/fields';
import { AccountFields } from 'api/fields/fields';
import { Field } from 'api/tasks';
import {
  ALL_FIELDS_QUERY_KEY,
  oneDay,
  TASK_FIELDS_QUERY_KEY,
} from 'queries/constants';

type AccountFieldsQueryOptionType = UseQueryOptions<
  AccountFields,
  unknown,
  AccountFields,
  typeof TASK_FIELDS_QUERY_KEY
>;
type AccountFieldsQueryResultType = UseQueryResult<AccountFields, unknown>;

export const useTaskFieldsBaseQuery = (
  queryOptions: AccountFieldsQueryOptionType = {},
): AccountFieldsQueryResultType =>
  useQuery(
    TASK_FIELDS_QUERY_KEY,
    () => {
      return FieldsAPI.getAllFields().then(
        (fields) =>
          fields.find(
            ({ objectType }) => objectType === FieldSectionType.Task,
          ) as AccountFields,
      );
    },
    {
      staleTime: oneDay,
      ...queryOptions,
    },
  );

type QueryOptionType = UseQueryOptions<
  Field[],
  unknown,
  Field[],
  typeof ALL_FIELDS_QUERY_KEY
>;
type QueryResultType = UseQueryResult<Field[], unknown>;

export const useAllFieldsBaseQuery = (
  queryOptions: QueryOptionType = {},
): QueryResultType => {
  return useQuery(
    ALL_FIELDS_QUERY_KEY,
    () => {
      return FieldsAPI.getAllFields().then((fields) =>
        fields.reduce((acc, field) => acc.concat(field.fields), [] as Field[]),
      );
    },
    {
      staleTime: oneDay,
      ...queryOptions,
    },
  );
};

export const useCompanyFieldsQuery = (
  queryOptions: QueryOptionType = {},
): QueryResultType =>
  useAllFieldsBaseQuery({
    ...queryOptions,
    select: (response) => {
      return response.filter(
        ({ objectType }) => objectType === FieldSectionType.Company,
      );
    },
  });
